import Layout from "@/views/layout/baseLayout.vue";
import loginComponent from "@/views/login";
import registerComponent from "@/views/register";
import schoolComponent from "@/views/school";
import schoolDetailComponent from "@/views/school/detail";
import teacherComponent from "@/views/teacher";
import studentDetailComponent from "@/views/student/detail";
import klassDetailComponent from "@/views/klass/detail";
import albumComponent from "@/views/album";
import albumDetailComponent from "@/views/album/detail";
import albumTempDetailComponent from "@/views/album/albumTempDetail";

import themeComponent from "@/views/theme";
import themeCreateComponent from "@/views/theme/create";
import publishComponent from "@/views/publish";
import klassCircleComponent from "@/views/klass";
import sensitiveComponent from "@/views/sensitive";
import externalComponent from "@/views/external";
import externalDetailComponent from "@/views/external/create";
import userInfoComponent from "@/views/userInfo";
import KlassTaskComponent from "@/views/assessment";
import assessmentListComponent from "@/views/assessment/assessmentList";
import assessmentComponent from "@/views/assessment/detail";
import assessmentTaskComponent from "@/views/assessment/archiveTask";


import notPermissionComponent from "@/views/error/notPermission";
import notFoundComponent from "@/views/error/notFound";

const whiteList = ["login", "register", "notPermission", "notFound"];
const constRoutes = [
    {
        path: "/login",
        name: "login",
        component: loginComponent,
    },
    {
        path: "/register",
        name: "register",
        component: registerComponent,
    },
    {
        path: "/403",
        name: "notPermission",
        component: notPermissionComponent,
    },
]

const asyncRoutes = [
    {
        path: "school",
        name: "school",
        component: schoolComponent,
        meta: {
            parent: [],
            code: ["school"],
        }
    },
    {
        path: "school/detail",
        name: "schoolDetail",
        component: schoolDetailComponent,
        meta: {
            parent: ["school"],
            code: [],
        }
    },
    {
        path: "/student/detail",
        name: "studentDetail",
        component: studentDetailComponent,
        meta: {
            parent: ["school"],
            code: ["studentDetail"],
            showBack: true,
        }
    },
    {
        path: "/teacher/detail",
        name: "teacherDetail",
        component: teacherComponent,
        meta: {
            parent: ["school"],
            // code: ["teacherDetail"],
            showBack: true,
        }
    },
    {
        path: "/klass/detail",
        name: "klassDetail",
        component: klassDetailComponent,
        meta: {
            parent: ["school"],
            code: ["klassDetail"],
            showBack: true,
        }
    },
    {
        path: "album",
        name: "album",
        component: albumComponent,
        meta: {
            parent: [],
            code: ["album"],
        }
    },
    {
        path: "album/detail",
        name: "albumDetail",
        component: albumDetailComponent,
        meta: {
            parent: ["album"],
            code: ["albumDetail"],
            showBack: true,
        }
    },
    {
        path: "albumTemp/detail",
        name: "albumTempDetail",
        component: albumTempDetailComponent,
        meta: {
            parent: ["album"],
            code: ["albumTempDetail"],
            showBack: true,
        }
    },

    {
        path: "klass/circle",
        name: "klassCircle",
        component: klassCircleComponent,
        meta: {
            parent: [],
            code: ["klassCircle"],
        }
    },

    {
        path: "klass/publish",
        name: "publish",
        component: publishComponent,
        meta: {
            parent: ["klassCircle"],
            code: ["publish"],
            showBack: true,
        }
    },

    {
        path: "klass/theme/list",
        name: "themeList",
        component: themeComponent,
        meta: {
            parent: ["klassCircle"],
            code: ["themeList"],
            showBack: true,
            classname: "p-right-0"
        }
    },

    {
        path: "klass/theme/create",
        name: "createTheme",
        component: themeCreateComponent,
        meta: {
            parent: ["klassCircle"],
            code: ["createTheme"],
            showBack: true,
        }
    },

    {
        path: "klass/theme/update",
        name: "updateTheme",
        component: themeCreateComponent,
        meta: {
            parent: ["klassCircle"],
            code: ["updateTheme"],
            showBack: true,
        }
    },
    {
        path: "sensitive",
        name: "sensitive",
        component: sensitiveComponent,
        meta: {
            parent: [],
            code: ["sensitive"],
        }
    },
    {
        path: "external",
        name: "external",
        component: externalComponent,
        meta: {
            parent: [],
        }
    },
    {
        path: "external/create",
        name: "externalCreate",
        component: externalDetailComponent,
        meta: {
            parent: ["external"],
            showBack: true,
        }
    },
    {
        path: "external/update",
        name: "externalUpdate",
        component: externalDetailComponent,
        meta: {
            parent: ["external"],
            showBack: true,
        }
    },
    {
        path: "userInfo",
        name: "userInfo",
        component: userInfoComponent,
        meta: {
            parent: [],
            showBack: true,
        }
    },
    {
        path: "assessment/task",
        name: "klassTask",
        component: KlassTaskComponent,
        meta: {
            parent: [],
            code: ["klassTask"],
        }
    },
    {
        path: "assessment/list",
        name: "assessmentList",
        component: assessmentListComponent,
        meta: {
            parent: ["klassTask"],
            code: ["assessmentList"],
            showBack: true,
            classname: "p-right-0"
        }
    },
    {
        path: "assessment",
        name: "assessment",
        component: assessmentComponent,
        meta: {
            parent: ["klassTask", "assessmentList"],
            code: ["assessment"],
            showBack: true,
            classname: "p-right-0"
        }
    },
    {
        path: "assessment/task/archive",
        name: "archivedTask",
        component: assessmentTaskComponent,
        meta: {
            parent: ["klassTask"],
            code: ["archivedTask"],
            showBack: true,
            classname: "p-right-0"
        }
    },
    {
        path: "assessment/archived/list",
        name: "archivedAssessmentList",
        component: assessmentListComponent,
        meta: {
            parent: ["klassTask"],
            code: ["archivedAssessmentList"],
            showBack: true,
            classname: "p-right-0"
        }
    },
]

const errorRoutes = [
    {
        path: "/*",
        name: "notFound",
        component: Layout,
        isRedirect: true,
        redirect: { name: "404" },
        children: [
            {
                path: "/404",
                name: "404",
                component: notFoundComponent,
            },
        ],
    },
]


export default {
    whiteList,
    constRoutes,
    asyncRoutes,
    errorRoutes
};
